import { HubSpotDeleteObjectsConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getHubspotDeleteObjectTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as HubSpotDeleteObjectsConfig;

	return [
		{
			id: 'use-variable-token',
			selector: '[data-tour="use-variable-token"]',
			content:
				'This option changes the Access Token input behavior to allow free text or expression inputs.',
		},
		{
			id: 'access-token',
			selector: '[data-tour="access-token"]',
			content: 'Required: The HubSpot access token that will be used to validate the request.',
		},
		...(config.accessToken.trim().length > 0
			? [
					{
						id: 'object-type',
						selector: '[data-tour="object-type"]',
						content:
							'Required: Once a valid HubSpot access token is provided the task will fetch a list of available objects from the HubSpot environment.',
					},
					{
						id: 'id-field',
						selector: '[data-tour="id-field"]',
						content:
							'Required: The field value taken from the input object that will be sent as the ID for the delete request. Note that the delete action will always delete using the "hs_object_id" field value.',
					},
					...(config.hubSpotObjectType === 'Contacts'
						? [
								{
									id: 'delete-action',
									selector: '[data-tour="delete-action"]',
									content:
										'Required: Determines if the delete will be permanent (GDPR compliant) or only archive the data. Note that this property is only applicable to GDPR sensitive objects like Contacts.',
								},
							]
						: []),
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
